<div class="add-cc-dialog">
  <div class="add-cc-dialog__header">
    <h1 class="add-cc-dialog__title">
      {{isSelectingStatements ? 'Create Proposal' : 'Create Cost Comparison'}}
    </h1>
    <button class="dialog-close" (click)="dialogRef.close()" type="button" aria-label="Close dialog">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
  <div class="add-cc-dialog__content">
    @if (isSelectingStatements) {
    <p class="add-cc-dialog__subtitle">Select one or more completed statements to create a cost comparison proposal.</p>

    @if (loading) {
    <div class="progress-spinner-wrapper">
      <div class="progress-spinner"></div>
    </div>
    }

    @if (!loading && completedStatements.length === 0) {
    <div class="empty-state-error">
      Merchant must have at least one completed Statement Analysis.
    </div>
    }

    @if (!loading && completedStatements.length > 0) {
    <table class="fees-table stmt-select-table full-width">
      <thead>
        <tr>
          <th class="stmt-select-table__checkbox-col">
            <button class="checkbox-btn" [class.checkbox-btn--checked]="isAllSelected()"
              [class.checkbox-btn--indeterminate]="selection.length > 0 && !isAllSelected()" (click)="masterToggle()"
              [attr.aria-label]="checkboxLabel()">
              @if (isAllSelected()) {
              <span class="material-symbols-outlined">check</span>
              } @else if (selection.length > 0) {
              <span class="material-symbols-outlined">remove</span>
              }
            </button>
          </th>
          <th (click)="sortBy('createdAt')">
            Date Uploaded {{sortColumn === 'createdAt' ? (sortDirection === 'asc' ? '↓' : '↑') : ''}}
          </th>
          <th (click)="sortBy('friendlyName')">
            Statement Name {{sortColumn === 'friendlyName' ? (sortDirection === 'asc' ? '↓' : '↑') : ''}}
          </th>
          <th (click)="sortBy('fileName')">
            PDF Name {{sortColumn === 'fileName' ? (sortDirection === 'asc' ? '↓' : '↑') : ''}}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (element of sortedStatements(); track element.id) {
        <tr (click)="toggleSelection(element)" class="stmt-select-table__row">
          <td class="stmt-select-table__checkbox-col">
            <button class="checkbox-btn" [class.checkbox-btn--checked]="isSelected(element)"
              (click)="$event.stopPropagation(); toggleSelection(element)" [attr.aria-label]="checkboxLabel(element)">
              @if (isSelected(element)) {
              <span class="material-symbols-outlined">check</span>
              }
            </button>
          </td>
          <td>{{element.createdAt | date:'MMMM d, yyyy'}}</td>
          <td>{{formatStatementName(element.friendlyName)}}</td>
          @if (element.fileName) {
          <td>{{formatPdfName(element.fileName)}}</td>
          } @else {
          <td><span class="statement-table__no-pdf" style="opacity: 0.7;"><i>Statement PDF not uploaded</i></span></td>
          }
        </tr>
        }
      </tbody>
    </table>
    }
    }

    @if (!isSelectingStatements) {
    <div class="proposal-preview-list">
      @for (costComparison of costComparisonObjects; track costComparison; let index = $index) {
      <div class="entity-card cc-preview-card">
        <form [formGroup]="costComparisonEditForms[index]" autocomplete="off" class="cc-preview-card__form-row">
          <div class="field field--inline">
            <label class="field__label">Name the Cost Comparison</label>
            <input class="field__input" type="text" placeholder="Name the Cost Comparison"
              formControlName="friendlyName" required>
          </div>
        </form>
        <div class="cc-preview-card__body">
          <div class="cc-preview-card__statements">
            <h4 class="cc-preview-card__statements-header">SELECTED STATEMENTS</h4>
            @for (stmtData of costComparison.statementData; track stmtData) {
            <div class="cc-preview-card__statement-row">
              <span class="material-symbols-outlined cc-preview-card__statement-icon">receipt</span>
              <span>{{stmtData.statementName}}</span>
            </div>
            }
          </div>
          <div class="cc-preview-card__rates">
            <table class="fees-table preview-table full-width">
              <thead>
                <tr>
                  <th>DISCOUNT RATES</th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (fee of costComparison.rateGroups; track fee) {
                <tr>
                  <td>{{fee.description}}</td>
                  <td class="content-right">{{fee.transactionRate | percent:'1.2-2'}}</td>
                  <td class="content-right">+</td>
                  <td class="content-right">
                    @if (fee.transactionFee) {
                    <span>{{fee.transactionFee | currency}}</span>
                    } @else {
                    <span>-</span>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  <div class="add-cc-dialog__actions">
    @if (isSelectingStatements) {
    <button class="cancel-button" type="button" (click)="dialogRef.close()">Cancel</button>
    <div class="add-cc-dialog__actions-right">
      <button class="confirm-button" (click)="selectStatements()" [disabled]="selection.length === 0">
        Next
      </button>
    </div>
    } @else {
    <div class="add-cc-dialog__actions-left change-statements-group" (click)="changeStatements()">
      <span class="material-symbols-outlined dialog-arrow-back">arrow_back</span>
      <button class="btn-link" type="button">Change Statement Selection</button>
    </div>
    <div class="add-cc-dialog__actions-right">
      <button class="cancel-button" type="button" (click)="dialogRef.close()">Cancel</button>
      <button class="confirm-button" type="button" (click)="createCCs()" [disabled]="isCreateDisabled()">
        Create Cost Comparison(s)
      </button>
    </div>
    }
  </div>
</div>